import React from 'react';
import { motion } from 'framer-motion';
import { Folder } from 'lucide-react';
const categories = [
// De las fotos
'Alarms & Beeps', 'Ambience', 'Deep', 'Epic', 'Flash', 'Glitches', 'Hits', 'Impacts', 'Jolt', 'Nature', 'Risers', 'Stress', 'Tones', 'Weird & Scary', 'Whooshes', 'Wind', 'Cars', 'Cigarettes', 'Drones', 'Fantasy', 'Fighting Foley', 'Guns', 'Impacts & Explosions', 'Planes & Choppers', 'Risers', 'Scary Horror', 'Science Fiction', 'Telephone', 'Tension Builders', 'Indoor', 'Materials & Elements', 'Urban', 'Foley', 'Pulses', 'Sweeps', 'Textures', 'Transitions Long', 'Transitions Short', 'Bad TV', 'Camera', 'Games', 'Phone', 'Radio', 'Vinyl',
// Extras profesionales del mismo estilo
'Cinematic Booms', 'Atmospheres', 'Dark Ambient', 'Distortion', 'Electricity', 'Fire & Flames', 'Footsteps', 'Glass & Debris', 'Hydraulics', 'Industrial', 'Mechanical', 'Metal Impacts', 'Ocean & Water', 'Rain & Thunder', 'Reverb Tails', 'Sci-Fi Drones', 'Servo Motors', 'Stingers', 'Sub Bass', 'Swells', 'Warfare', 'Wobblers', 'Zaps & Sparks'];
export function SoundEffects() {
  return <section className="py-16 px-4 md:px-8 max-w-7xl mx-auto" data-id="element-179">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-10" data-id="element-180">
        <h2 className="text-xl md:text-3xl font-black uppercase tracking-tight mb-2" data-id="element-181">
          <span className="text-primary" data-id="element-182">
            +2000 EFECTOS DE SONIDO, +40 CARPETAS
          </span>{' '}
          CON MILES DE EFECTOS DE SONIDO PROFESIONALES
        </h2>
        <div className="w-full max-w-4xl mx-auto h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent mt-6" data-id="element-183"></div>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} transition={{
      duration: 0.8
    }} viewport={{
      once: true
    }} className="bg-white rounded-2xl p-6 md:p-10" data-id="element-184">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-3" data-id="element-185">
          {categories.map((category, index) => <div key={index} className="flex items-center bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md px-3 py-2 text-xs font-semibold transition-colors cursor-default border border-gray-200" data-id="element-186">
              <Folder className="w-3.5 h-3.5 mr-2 text-gray-500 flex-shrink-0" data-id="element-187" />
              <span className="truncate" data-id="element-188">{category}</span>
              <div className="ml-auto pl-2 text-gray-400" data-id="element-189">⋮</div>
            </div>)}
        </div>
      </motion.div>
    </section>;
}